import { Dialog } from "@mui/material";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState, useEffect } from "react";

const ReviewImageGallery = ({ images, startIndex = 0, onClose }) => {

  const [index, setIndex] = useState(startIndex);

  useEffect(() => {
    setIndex(startIndex);
  }, [startIndex]);

  const prev = () => {
    setIndex(index === 0 ? images.length - 1 : index - 1);
  };

  const next = () => {
    setIndex(index === images.length - 1 ? 0 : index + 1);
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="lg"
    >

      <div className="relative bg-black">

        <img
          src={images[index]}
          className="max-h-[80vh] object-contain mx-auto"
        />

        {/* Left */}
        <button
          onClick={prev}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full"
        >
          <FiChevronLeft size={22}/>
        </button>

        {/* Right */}
        <button
          onClick={next}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full"
        >
          <FiChevronRight size={22}/>
        </button>

      </div>

    </Dialog>
  );
};

export default ReviewImageGallery;